// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var ReactUtils = require("../../../shared/src/ReactUtils.bs.js");
var BrowserStyle = require("../BrowserStyle.bs.js");

function sectionHeader(maxNumberOfLines) {
  return Curry._1(BrowserStyle.style, BrowserStyle.withFont(maxNumberOfLines, /* Quicksand */0, /* Medium */3, /* Bold */2)({
                  hd: BrowserStyle.color({
                        TAG: /* Grey */2,
                        _0: /* Dark */1
                      }),
                  tl: {
                    hd: BrowserStyle.textOverflow("ellipsis"),
                    tl: {
                      hd: BrowserStyle.overflow("hidden"),
                      tl: /* [] */0
                    }
                  }
                }));
}

var Styles = {
  sectionHeader: sectionHeader
};

function BrowserComponents_SectionHeader(Props) {
  var className = Props.className;
  var children = Props.children;
  var maxNumberOfLines = Props.maxNumberOfLines;
  return React.createElement("div", {
              className: BrowserStyle.Utils.extendBaseStyle(sectionHeader(maxNumberOfLines), className)
            }, React.createElement(ReactUtils.S.make, {
                  children: children
                }));
}

var StyleTypes;

var make = BrowserComponents_SectionHeader;

exports.StyleTypes = StyleTypes;
exports.Styles = Styles;
exports.make = make;
/* react Not a pure module */
